
import axios from '@/utils/request'

export default {
    // 2020-08-21
    variantMaps(params) {
        return axios.put('/mms/boms/variant-maps/find-by-ids', params)
    },
    // 2020-08-22
    variantMapInsertBatch(id, params) {
        return axios.post('/mms/boms/' + id + '/variant-maps/insert-batch', params)
    },
    // 2020-08-21
    deleteVariantMaps(id, params) {
        return axios.put('/mms/boms/' + id + '/variant-maps/delete-by-ids', params)
    },
    // 2020-08-21
    variantMapsExportExcel(params) {
        return axios.put('/mms/boms/variant-maps/export-excel', params)
    },
    // 2021-01-03
    editVariantMaps(id, variantMapId, params) {
        return axios.put('/mms/boms/' + id + '/variant-maps/' + variantMapId + '/edit-by-id', params)
    },
}

